var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.33333C11 4.38781 13.4624 2 16.5 2C19.5376 2 22 4.38781 22 7.33333C22 10.366 19.194 12.5993 17.2641 13.6317C16.7859 13.8875 16.2141 13.8875 15.7359 13.6317C13.806 12.5993 11 10.366 11 7.33333ZM16.5 10C17.8807 10 19 8.88071 19 7.5C19 6.11929 17.8807 5 16.5 5C15.1193 5 14 6.11929 14 7.5C14 8.88071 15.1193 10 16.5 10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62334 6.04584C9.54242 6.46204 9.5 6.89234 9.5 7.33333C9.5 9.3349 10.4281 10.9904 11.5204 12.2261C12.6117 13.4605 13.9526 14.3788 15.0284 14.9543C15.9486 15.4466 17.0514 15.4466 17.9716 14.9543C17.981 14.9493 17.9905 14.9442 18 14.9391V20.3666C18 21.2687 17.2837 22 16.4 22H13.2V18.7332C13.2 16.929 11.7673 15.4664 10 15.4664C8.23269 15.4664 6.8 16.929 6.8 18.7332V22H3.6C2.71634 22 2 21.2687 2 20.3666V12.0203C2 11.476 2.26551 10.9675 2.70811 10.6642L9.10811 6.27732C9.26816 6.16761 9.44279 6.09045 9.62334 6.04584Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderHouse);
export default __webpack_public_path__ + "static/media/placeholder-house.ee8a6b4ad6e616786d24aa41b80b1ad6.svg";
export { ForwardRef as ReactComponent };